export const environment = {
  production: false,
  apiBase:  'https://api.seodag.sogak.com.mx',   //http://200.57.229.94/siniestros_graves
  env: 'dev'
};
//http://siniestros_graves.com.devel:8080